const colors = {
    purple: { id: 1 },
    blue: { id: 2 },
    red: { id: 3 },
    green: { id: 4 },
};

export default colors;
